import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslatePipe } from '@ngx-translate/core';
import { FocusAndSelectDirective } from '../../directive/focus-and-select.directive';
import { LoaderComponent } from '../../loader/loader.component';
import { FormField } from '../form-field.component';
import { FormFieldError } from '../uix-forms.utils';

@Component({
  selector: 'app-form-field-text',
  templateUrl: './form-field-text.component.html',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatButtonModule, MatIconModule, LoaderComponent, FocusAndSelectDirective, TranslatePipe],
})
export class FormFieldTextComponent extends FormField {
  @Input()
  multiline = false;

  @Input()
  type = 'text';

  @Input()
  maxLength = 500;

  @Input()
  suffixButtonIcon: string;

  @Input()
  suffixButtonAction: () => void;

  @Input()
  minLength: number;

  @Input()
  minValue: string;

  @Input()
  maxValue: string;

  @Input()
  displayFn: Function;

  // Only displays the first error in Mat-error.
  displayedErrors(): FormFieldError[] {
    return this.errors
      .filter((e: FormFieldError) => {
        return this.formGroup.controls[this.field].hasError(e.error);
      })
      .slice(0, 1);
  }
}
